
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "privacyPolicyDialog",
components: {
Popup,
},
props: {
isShow: Boolean,
title: String,
},
data() {
return {
sureList: [
{ title : '名称',value: '用途',value2: 'SDK所使用的个人信息及用途',value3: '收集个人信息的方式'},
{ title : '微信开放平台 SDK',value: '将内容分享到微信',value2: '无',value3: '无'},
{ title : '腾讯orc-SDK识别',value: '图片身份证识别',value2: '无',value3: '无'}
],
showDialog: false,
};
},
watch: {
isShow(newV, oldV) {
this.showDialog = newV;
},
},
created() {
this.showDialog = this.isShow;
},
methods: {
closeDialog() {
this.$emit("close");
},
},
};



// WEBPACK FOOTER //
// ./src/components/login/agreement/privacyPolicyDialog.vue